<div class="status-bar" role="status">
    <div class="status-info">
        @if (showInfoMessage) {
        <div class="status-item">
            <mat-icon class="status-icon">info</mat-icon>
            <span class="status-message">{{'FILE_MENU_INFO' | translate}}</span>
        </div>
        }
    </div>
    <span class="status-message copyright">{{'STATUS_BAR_COPYRIGHT' | translate: { year: currentYear } }}</span>
</div>
